import { useStorage } from '@vueuse/core'
import { nanoid } from 'nanoid'
import { defineStore } from 'pinia'
import type { DefineComponent } from 'vue'
import { ref } from 'vue'

import { immutableRemoveAt } from '@/utils/arrays'

export type NotificationTypes = 'success' | 'error' | 'info' | 'warning'
export type Button = {
  type: 'button'
  text: string,
  // color: 'error',
  handler: (data: { notification: Notification}) => void
} | {
  type: 'spacer'
}

export interface Notification {
  id: string
  type: NotificationTypes
  message: string
  title?: string
  duration: number
  progress: number
  show: boolean
  buttons: Button[]
  template?: DefineComponent
  close: boolean
}

export const useNotifications = defineStore('notifications', () => {
  const notifications = ref<Notification[]>([])
  // const notifications = useStorage<Notification[]>('notifications', [])

  const notify = (
    type: Notification['type'],
    message: string,
    options?: Partial<Notification>,
  ) => {
    const id = nanoid()
    notifications.value.push({
      id,
      type,
      message,
      title: options?.title,
      progress: 100,
      duration: options?.duration ?? 5000,
      show: true,
      buttons: options?.buttons ?? [],
      template: undefined,
      close: options?.close ?? true,
    })
  }

  const success = (
    message: string,
    options?: Partial<Notification>,
  ) => {
    return notify('success', message, options)
  }

  const info = (
    message: string,
    options?: Partial<Notification>,
  ) => {
    return notify('info', message, options)
  }

  const error = (
    message: string,
    options?: Partial<Notification>,
  ) => {
    return notify('error', message, options)
  }

  const warning = (
    message: string,
    options?: Partial<Notification>,
  ) => {
    return notify('warning', message, options)
  }

  const close = (id: string) => {
    console.log('id', id)
    console.log('notifications', notifications.value.map(x => x.id))
    const notification = getNotification(id)
    console.log('notification', notification)

    if (notification) {
      const index = getNotificationIndex(notification.id)
      console.log('index', index)
      notifications.value = immutableRemoveAt(notifications.value, index)
      console.log('notifications', notifications.value.map(x => x.id))
    }
  }

  const clear = () => {
    notifications.value = []
  }

  const getNotification = (id: string) => {
    return notifications.value.find((notification) => notification.id === id)
  }

  const getNotificationIndex = (id: string) => {
    return notifications.value.findIndex((notification) => notification.id === id)
  }

  const setProgress = (id: string, progress: number) => {
    const notificationIndex = notifications.value.findIndex((notification) => notification.id === id)
    if (notificationIndex !== -1 && notifications.value[notificationIndex]) {
      const notif = notifications.value[notificationIndex]
      if (notif) {
        notif.progress = progress
      }
    }
  }

  return {
    notifications,

    notify,
    success,
    info,
    error,
    warning,

    clear,
    close,
    setProgress,
  }
})
